import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type ProductEntityTableName =
    | 'products'
    | 'inventory_products'
    | 'inventory_changes';

export type PreparedProductData = {
    record: Model;
    table: ProductEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: ProductEntityTableName,
    operation: ValidationOperation,
): PreparedProductData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedProductData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
